import axios from 'axios';
import { useContextStore } from '@wholebodyapp/stores';
import ToastEventBus from '@wholebodyapp/ui-components/src/toast-service/toast-event-bus.js';
import { getCookie } from '@wholebodyapp/utils/cookies';
import router from '../router/router.js';
import { ApiError } from '../errors/api-error.js';
// create a new axios singleton insance, and export it. 


export const $http = axios.create();


// add some interceptors! 
$http.interceptors.request.use(
  config => {
    const context = useContextStore();
    if (!config.headers) config.headers = {};
    config.headers['scope'] = context.getScope;
    return config;
  },
  error => Promise.reject(error)
);

$http.interceptors.response.use(
  response => {
    const context = useContextStore();
     // set it if ya' got it.
    // we can eithr aarse teh 'set-cookie' header, or check the
    // cookie directly....
    const expiry = getCookie('server-expires');
    // really should be expires!, or the countdown timer
    // context.setScope(expiry);
    return response;
  },
  error => {
    const apiError = new ApiError(error);

    if (apiError.toastMessage)
      ToastEventBus.emit('add', apiError.toastMessage);

    return Promise.reject(apiError);
  }
);



